import React from "react";
import { Button } from "antd";
import { PlusOutlined } from "@ant-design/icons";

interface Props {
  title: string;
  onAdd?: () => void;
  addLabel?: string;
  extra?: React.ReactNode;
}

const PageHeader: React.FC<Props> = ({ title, onAdd, addLabel = "추가", extra }) => (
  <div
    style={{
      display: "flex",
      alignItems: "center",
      justifyContent: "space-between",
      marginBottom: 20,
    }}
  >
    <h2 style={{ color: "#4fc3f7", margin: 0, fontSize: 22 }}>{title}</h2>
    <div style={{ display: "flex", gap: 8 }}>
      {extra}
      {onAdd && (
        <Button type="primary" icon={<PlusOutlined />} onClick={onAdd}>
          {addLabel}
        </Button>
      )}
    </div>
  </div>
);

export default PageHeader;
